import React, { useState } from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import { LayoutDashboard, Building2, Users, Network, KeySquare, BarChart2, Terminal, LogOut, TicketCheck } from 'lucide-react';
import { useAdminAuth } from '../../context/AdminAuthContext';

const NAV = [
  { to: '/inqlect-admin',           label: 'Overview',   icon: LayoutDashboard, end: true },
  { to: '/inqlect-admin/tenants',   label: 'Tenants',    icon: Building2 },
  { to: '/inqlect-admin/users',     label: 'Users',      icon: Users },
  { to: '/inqlect-admin/channels',  label: 'Channels',   icon: Network },
  { to: '/inqlect-admin/licences',  label: 'Licences',   icon: KeySquare },
  { to: '/inqlect-admin/analytics', label: 'Analytics',  icon: BarChart2 },
  { to: '/inqlect-admin/logs',      label: 'Logs',       icon: Terminal },
  { to: '/inqlect-admin/support',   label: 'Support',    icon: TicketCheck },
];

export default function AdminLayout() {
  const { logoutAdmin }       = useAdminAuth();
  const navigate              = useNavigate();
  const [confirmLogout, setConfirmLogout] = useState(false);

  function handleLogout() {
    logoutAdmin();
    navigate('/inqlect-admin/login', { replace: true });
  }

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <span className="admin-brand-dot" />
          <span>InqLect Admin</span>
        </div>

        <nav className="admin-nav">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `admin-nav-item${isActive ? ' active' : ''}`}
            >
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>

        <button className="admin-nav-item admin-logout" onClick={() => setConfirmLogout(true)}>
          <LogOut size={16} />
          Logout
        </button>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>

      {confirmLogout && (
        <div className="admin-modal-backdrop" onClick={() => setConfirmLogout(false)}>
          <div className="admin-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 380 }}>
            <h3 className="admin-modal-title">Log out?</h3>
            <p style={{ fontSize: 13, color: 'var(--clr-text-secondary)', margin: '12px 0 20px' }}>
              You will be returned to the admin login screen.
            </p>
            <div className="admin-form-actions">
              <button className="admin-btn-secondary" onClick={() => setConfirmLogout(false)}>Cancel</button>
              <button className="admin-btn-primary" onClick={handleLogout}>Log out</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
